import { t } from 'i18next'
import type { FieldValues } from 'react-hook-form'

export class VagaValidator<TFieldValues extends FieldValues = FieldValues> {
  private readonly vagaIds: TFieldValues['informacoesIniciais']['vagaIds']
  private readonly possuiAcessoriosExtras: boolean
  private readonly simulacaoUnidade: TFieldValues['informacoesIniciais']['simulacaoUnidade']

  constructor({
    simulacaoUnidade,
    vagaIds,
    possuiAcessoriosExtras,
  }: {
    simulacaoUnidade: TFieldValues['informacoesIniciais']['simulacaoUnidade']
    possuiAcessoriosExtras: boolean
    vagaIds: TFieldValues['informacoesIniciais']['vagaIds']
  }) {
    this.vagaIds = vagaIds
    this.simulacaoUnidade = simulacaoUnidade
    this.possuiAcessoriosExtras = possuiAcessoriosExtras
  }

  validate(): string | null {
    if (!this.simulacaoUnidade) return null
    if (!this.simulacaoUnidade.produto.acessorioObrigatorio && !this.possuiAcessoriosExtras) return null
    if (!this.vagaIds.length) return t('proposta:informacoes_iniciais.cards.vaga_padrao.required')
    return null
  }
}
